import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { TemplateClass } from '../../template';
import { ConfigService } from '../configuration-service/configuration.service';
export class TemplateService {
private defaultTemp: TemplateClass;
private hashtable = [];
/**
 * @param {?} http
 * @param {?} configService
 */
constructor(private http: HttpClient,
private configService: ConfigService) { }
/**
 * @param {?} name
 * @param {?} templatesObject
 * @param {?} templateFolder
 * @return {?}
 */
loadTemplateJson(name: string, templatesObject: any, templateFolder): Observable<Object> {

    let /** @type {?} */ config = this.configService.getConfiguration();
    let /** @type {?} */ url = '';
    let /** @type {?} */ defaultDirectory = 'default';

    if (config != null && config.templateURL != null) {
      url = config.templateURL;
      if (config.defaultDirectory != null) { defaultDirectory = config.defaultDirectory; }
    }
    if (!url.endsWith('/')) { url = url + '/'; }
    if (templateFolder == null || templateFolder === '') { templateFolder = defaultDirectory; }

    let /** @type {?} */ path = templateFolder.split('/');
    if (path.length > 1) {
      if (!templateFolder.endsWith('.json')) { templateFolder = templateFolder + '.json'; }
      url = url + templateFolder;
    } else {
      if (templateFolder === '') {
        url = url + name + '-template.json';
      } else {
        url = url + templateFolder + '/' + name + '-template.json';
      }
    }

    const /** @type {?} */ headers = new HttpHeaders().set('fusion-component-template', url);

    return this.http.get(url, { headers: headers }).map(res => {
      return res;
    })
    .catch((error: any) => {
      return Observable.throw('Server error');
    });
  }
/**
 * @return {?}
 */
getTemplate(): TemplateClass {
    return this.defaultTemp;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ConfigService, },
];
}

function TemplateService_tsickle_Closure_declarations() {
/** @type {?} */
TemplateService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TemplateService.ctorParameters;
/** @type {?} */
TemplateService.prototype.defaultTemp;
/** @type {?} */
TemplateService.prototype.hashtable;
/** @type {?} */
TemplateService.prototype.http;
/** @type {?} */
TemplateService.prototype.configService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
